import { render, staticRenderFns } from "./zen-survey.vue?vue&type=template&id=0b8bd47c&scoped=true&lang=pug"
import script from "./zen-survey.vue?vue&type=script&lang=js"
export * from "./zen-survey.vue?vue&type=script&lang=js"
import style0 from "./zen-survey.vue?vue&type=style&index=0&id=0b8bd47c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8bd47c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/docker/code/frontend/components/Header.vue').default,Body: require('/home/docker/code/frontend/components/Body.vue').default,Footer: require('/home/docker/code/frontend/components/Footer.vue').default,ConsultationNotes: require('/home/docker/code/frontend/components/ConsultationNotes.vue').default,ConsultationChecklist: require('/home/docker/code/frontend/components/ConsultationChecklist.vue').default,ConsultationScripts: require('/home/docker/code/frontend/components/ConsultationScripts.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
